module.exports = __webpack_public_path__ + "static/media/heart-on.ac7e0add.png";